export const APP_HOME_PATH = "/app/datascope";

export const APP_ROUTES = {
  root: "/app",
  datascope: "/app/datascope",
  pinboards: "/app/pinboards",
  knowledgeGaps: "/app/knowledge-gaps",
  agents: "/app/agents",
  knowledgebase: "/app/knowledgebase",
  explore: "/app/explore",
  users: "/app/users",
  settings: "/app/settings",
} as const;
